// extracted by mini-css-extract-plugin
module.exports = {"base":"term_base__3nguM","removedTerm":"term_removedTerm__1L7Nb","value":"term_value__arkD9"};